export default __webpack_public_path__ + "static/media/printer.a4ad926b.svg";